import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

import PriceSection from './PriceSection'
import Limitation from './Limitation'
import AdditionalViews from './AdditionalViews'

function PricingPlan({
  isActive,
  title,
  features,
  limitations,
  monthlyPrice = null,
  yearlyPrice = null,
  additionalViews,
}) {
  return (
    <div className="col-12 col-md-6 col-lg-3 pricing-plan-wrapper">
      <div className={`pricing-plan ${isActive ? 'pricing-plan--green-border pricing-plan--locked' : ''}`}>
        <div className="pricing-plan__inner-section pricing-plan__inner-section--space-between">
          <h4 className="heading-20 u-mb0 u-mr10">{title}</h4>
          {isActive && (
            <span className="pricing-plan__current-label">Current plan</span>
          )}
        </div>
        <hr />
        <div className="pricing-plan__inner-section">
          {features.map((feature) => (
            <p key={`${title}-feature-${feature.title}`} className="text-light-grey">
              {feature.isPresent ? (
                <Icon type={['far', 'check-circle']} className="is-green" />
              ) : (
                <Icon type={['far', 'times-circle']} className="is-red" />
              )}
              {feature.title}
            </p>
          ))}
        </div>
        <hr />
        <div className="pricing-plan__inner-section">
          {limitations.map((limitation) => (
            <Limitation key={`${title}-limitation-${limitation.title}`} {...limitation} />
          ))}
        </div>
        <hr />
        <div className="pricing-plan__inner-section">
          <PriceSection value={yearlyPrice}>
            <div className="pricing-plan__description text-light-grey">(Yearly subscription)</div>
            <hr />
          </PriceSection>
          <PriceSection value={monthlyPrice}>
            <div className="pricing-plan__description text-light-grey">(Monthly subscription)</div>
            <hr />
          </PriceSection>
          <AdditionalViews
            {...additionalViews}
          />
        </div>
      </div>
    </div>
  )
}

PricingPlan.propTypes = {
  isActive: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  features: PropTypes.array.isRequired,
  limitations: PropTypes.array.isRequired,
  monthlyPrice: PropTypes.number,
  yearlyPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  additionalViews: PropTypes.object.isRequired,
}

export default PricingPlan
